import namespaceHelper from '@/shared/helpers/namespace-helper';

import { namespace, AlertGetters } from './types';

const _alertGetters = namespaceHelper.removeNamespace(namespace, AlertGetters);

export default {
  [_alertGetters.GET_ALERTS]: state => {
    return state.alerts;
  }
};
